import React from 'react';
import { BookOpen } from 'lucide-react';
export function ChaptersSection() {
  const chapters = [{
    id: 1,
    title: 'La verdad que nadie te dice'
  }, {
    id: 2,
    title: 'Mentalidad de jugador ganador'
  }, {
    id: 3,
    title: 'El error #1 que te está haciendo perder'
  }, {
    id: 4,
    title: 'Configuración PRO (sensibilidad, HUD, gráficos, audio)'
  }, {
    id: 5,
    title: 'Posicionamiento inteligente'
  }, {
    id: 6,
    title: 'Cómo ganar más enfrentamientos'
  }, {
    id: 7,
    title: 'Errores de novato que parecen normales'
  }, {
    id: 8,
    title: 'Estrategias para subir más rápido'
  }, {
    id: 9,
    title: 'Rutina de Dominio en 7 Días'
  }, {
    id: 10,
    title: 'El jugador que vas a decidir ser'
  }];
  return <section className="py-24 bg-slate-950" data-id="element-22">
      <div className="container mx-auto px-4" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4 uppercase" data-id="element-25">
            Qué hay dentro del <span className="text-blue-500" data-id="element-26">Ebook</span>
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-27">
            Todo lo que necesitás para transformar tu juego
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-28">
          {chapters.map(chapter => <div key={chapter.id} className="group relative bg-slate-900 p-6 border border-slate-800 hover:border-blue-500/50 transition-all duration-300 overflow-hidden" data-id="element-29">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-30">
                <BookOpen className="w-12 h-12 text-blue-500" data-id="element-31" />
              </div>

              <div className="flex items-start gap-4 relative z-10" data-id="element-32">
                <span className="flex items-center justify-center w-10 h-10 bg-slate-800 text-blue-400 font-bold rounded group-hover:bg-blue-600 group-hover:text-white transition-colors shrink-0" data-id="element-33">
                  {chapter.id}
                </span>
                <h3 className="text-xl font-bold text-slate-200 group-hover:text-white transition-colors pt-1" data-id="element-34">
                  {chapter.title}
                </h3>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-35">
          <p className="text-2xl font-bold text-white uppercase tracking-widest" data-id="element-36">
            No es teoría.{' '}
            <span className="text-red-500 border-b-2 border-red-500" data-id="element-37">
              Es método.
            </span>
          </p>
        </div>
      </div>
    </section>;
}